(() => {
  // cart-src/guard.js
  function installCartEditGuard(win = window, navigate = (url) => win.location.assign(url)) {
    if (win.__clauraCartEditGuard) return;
    win.__clauraCartEditGuard = true;
    const actions = '[data-cart-remove], [data-quantity-wrapper], [name="checkout"], a[href*="/checkout"], .shopify-payment-button, .additional-checkout-buttons';
    const guard = (event) => {
      if (win.__clauraCartLensEditor) return;
      let pending;
      try {
        pending = win.localStorage.getItem("claura.cart.lens-edit.v1");
      } catch {
        return;
      }
      if (!pending) return;
      const target = event.target;
      const isCartSubmit = event.type === "submit" && target.matches?.('[data-cart-form], form[action*="/cart"], form[action*="/checkout"]');
      if (!isCartSubmit && !target.closest?.(actions)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      navigate(`${win.Shopify?.routes?.root || "/"}cart`);
    };
    for (const name of ["click", "input", "change", "submit"]) win.document.addEventListener(name, guard, true);
  }
  if (typeof window !== "undefined") installCartEditGuard();
})();
